// extracted by mini-css-extract-plugin
export default {"navigation_link":"_3ozlOkcJwyX4tifnUKHULy","animated_arrow_right":"_2Y0kGi1kGYWj7M6gkuagdr","arrow-animation":"_1WOONzB4epAQdFz5F39Qp6"};